export function highlightSearchedValue(
  label: string,
  searched: string,
  highlightColor = "#477CBF",
): string {
  return label.replace(
    new RegExp(searched, "gmi"),
    (match: string) =>
      `<b class="highlight font-semibold" style="color: ${highlightColor};">${match}</b>`,
  );
}
